export const headerData = {
  name: "Sri Srinivasan S",
  title: "Hello! I am",
  desciption:
    "Hi, I'm Sri Srinivasan, a dedicated and enthusiastic Web Developer. I possess a strong ability to learn quickly and have a self-motivated approach to continuously improve my skills. I have a passion for exploring new technologies and solving problems.",
  image:
    "https://iili.io/HU8UMqg.jpg",
  resumePdf:
    "https://drive.google.com/file/d/1hxLOsf2T3ANL307E-fFhK4wpHRBUSHRq/view?usp=sharing",
};
